const api_url = process.env.REACT_APP_HOST + process.env.REACT_APP_API_URL;

export function readAllModules(callback) {
    console.log("****************************************************");
    console.log("url: " + process.env.REACT_APP_HOST);
    console.log("default_path: " + process.env.REACT_APP_API_URL);
    console.log("****************************************************");

    const uri = "module\\readAllModules.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });
}

export function readAllHelp(callback) {

    const uri = "help\\readHelp.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });
}

export function readAllMaterials(callback) {

    const uri = "material\\readAllMaterialsConfigurator.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });

}

export function readAllRooms(callback) {

    const uri = "room\\readRooms.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });

}

export function readAllPlints(callback) {

    const uri = "plint\\readPlints.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });

}

export function readSettings(callback) {

    const uri = "settings\\readSetting.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });

}

export function readFeatures(callback) {

    const uri = "feature\\readAllFeaturesWithTypeName.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });

}

export function readFeatureTypes(callback) {

    const uri = "feature_type\\readAllFeatureTypes.php";

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        }
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });

}

export function readOrderStatus(order_id, callback) {

    const uri = "order\\readOrderStatus.php"

    fetch(api_url + uri, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Access-Control-Allow-Origin",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            order_id: order_id
        })
    })
        .then(response => response.json())
        .then(result => {

            if (typeof callback === "function") {
                callback(result.records)
            }
        })
        .catch(error => {
            console.log(error);
        });
}